// Utility functions for preloading cart resources

// Register service worker for caching
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw-preloader.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
};

let counterStyleLink = null;
const preloadedIcons = new Map();

// Preload critical CSS for counter widget
export const preloadCounterWidgetStyles = () => {
  if (counterStyleLink) return;

  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'style';
  link.href = '/static/css/counter-widget.css';
  link.setAttribute('data-counter-widget-style', 'true');

  link.onload = () => {
    link.rel = 'stylesheet';
    link.removeAttribute('as');
    link.onload = null;
  };

  link.onerror = () => {
    link.remove();
    counterStyleLink = null;
  };

  counterStyleLink = link;
  document.head.appendChild(link);
};

// Preload counter widget icons
export const preloadCounterWidgetIcons = () => {
  const icons = [
    '/static/media/icon-increment.svg',
    '/static/media/icon-decrement.svg'
  ];
  
  icons.forEach(iconUrl => {
    if (preloadedIcons.has(iconUrl)) return;

    const img = new Image();
    img.decoding = 'async';
    img.src = iconUrl;
    preloadedIcons.set(iconUrl, img);
  });
};

// Preload cart API endpoints
export const preloadCartAPI = () => {
  // Prefetch cart data if user is logged in
  if (localStorage.getItem('isLoggedIn') === 'true') {
    fetch('/api/cart', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('userToken')}`
      }
    }).catch(() => {
      // Silently fail - this is just for preloading
    });
  }
};

// Initialize all preloading strategies
export const initializePreloader = () => {
  registerServiceWorker();
  preloadCounterWidgetStyles();
  preloadCounterWidgetIcons();

  // Initialize icon fallback observer
  import('../common/components/CustomCounterWidget/iconFallback')
    .then(({ observeCounterWidgets }) => {
      observeCounterWidgets();
    })
    .catch((error) => {
      console.error('Failed to initialize counter widget fallbacks', error);
    });

  // Preload cart API after a short delay
  setTimeout(preloadCartAPI, 1000);
  
  // Send message to service worker to preload counter widget resources
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'PRELOAD_COUNTER_WIDGET'
    });
  }
};

// Preload resources when hovering over cart-related links
export const preloadOnHover = (element) => {
  element.addEventListener('mouseenter', () => {
    preloadCounterWidgetStyles();
    preloadCounterWidgetIcons();
  }, { once: true });
};
